module.exports = __webpack_public_path__ + "img/msu3-char-3.d97ffd84.png";